/* global axios */
import ApiClient from '../ApiClient';

class CopilotPromptsAPI extends ApiClient {
    constructor() {
        super('', { accountScoped: true });
    }

    buildUrl(assistantId) {
        return `${this.baseUrl()}/captain/assistants/${assistantId}/copilot_prompts`;
    }

    index(assistantId) {
        return axios.get(this.buildUrl(assistantId));
    }

    create(assistantId, data) {
        return axios.post(this.buildUrl(assistantId), {
            copilot_prompt: data,
        });
    }

    update(assistantId, promptId, data) {
        return axios.patch(`${this.buildUrl(assistantId)}/${promptId}`, {
            copilot_prompt: data,
        });
    }

    destroy(assistantId, promptId) {
        return axios.delete(`${this.buildUrl(assistantId)}/${promptId}`);
    }

    restore(assistantId, promptId) {
        return axios.post(
            `${this.buildUrl(assistantId)}/${promptId}/restore`
        );
    }
}

export default new CopilotPromptsAPI();
